import { observer } from 'mobx-react-lite';
import Sidebar from '../Sidebar/Sidebar';
import ProjectForm from '../ProjectForm/ProjectForm';
import { useMainContext } from '../../../hooks/useMainContext';
import { STEP_TYPE } from '../../../__utils/UiConst';
import { WorkSpace } from '../WorkSpace';
import PdfUploadModel from '../ProjectForm/PdfUploadModel';

const NewWorkspace = observer(() => {
    const { uiManager } = useMainContext();

    return (
        <>
            <div className="h-[calc(100dvh-80px)] flex w-full">
                <Sidebar />
                <div className="flex-1 bg-theme-header-bg">
                    {uiManager.selectedStep === STEP_TYPE.CREATE ? (
                        <ProjectForm />
                    ) : (
                        <WorkSpace />
                    )}
                </div>
            </div>
            <PdfUploadModel />
        </>
    );
});

export default NewWorkspace;
